import React from "react";
import "../../styles/SearchInput.css";
import { faMagnifyingGlass, faXmark } from "@fortawesome/free-solid-svg-icons";
import {FaIcon} from "../../shared/ui";
const SearchInput = ({
  value,
  onChange,
  onClear,
  placeholder,
    loading,
    disabled,
}) => (
  <div className="search-input-wrapper">
    <span className="search-icon">
      <FaIcon icon={faMagnifyingGlass} size="lg"/>
    </span>
    <input
      type="text"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className="search-input"
      disabled={disabled}
      maxLength={80}
    />
    {loading && (
      <span className="search-spinner" style={{ position: "absolute", right: 36 }}>
        {/* Use your spinner here, e.g. */}
        <div className="spinner" style={{ width: 18, height: 18 }} />
      </span>
    )}
    {value && (
      <button className="clear-btn" onClick={onClear} type="button">
        <FaIcon icon={faXmark} size="sm"/>
      </button>
    )}
  </div>
);


export default SearchInput;
